import api from "../../../helpers/api";

export const getMyProductsSupplier = (body) =>
	api.post("supplier-product/search-supplier-products/", { ...body });

export const getMySupplierProduct = (id) =>
	api.get(`supplier-product/get-single-product/${id}`);

export const createMySupplierProduct = (formData) =>
	api.post("supplier-product-staging/create", { ...formData });

export const updateMySupplierProduct = (id, formData) =>
	api.post(`supplier-product-staging/update/${id}`, { ...formData });

export const getMyProductsSupplierPictures = () =>
	api.get("supplier-product/get-products-pictures?offset=0&size=10");
